import {
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core'
import React from 'react'
import { StyleSheet, View } from 'react-native'
import { TableHeaderSort } from './TableHeaderSort'
import { SelectedRowProps, TableDataSource, TableSortColumnInfo } from './TableData'
import { useTranslation } from 'react-i18next'

export interface HightLightTableColum {
  title: string
  fieldName: string
  // colStyles?: React.CSSProperties
  minWidth?: number
  disabled?: boolean
  isHightLightCol?: (selectedItem: SelectedRowProps) => boolean
  rowRender?: (props: SelectedRowProps) => JSX.Element
}

type HightLightTableProps = {
  displayedColumns: Array<HightLightTableColum>
  dataSource: TableDataSource[]
  tableContainerClassName?: string
  isPagination?: boolean
  totalRecord?: number
  pageSize?: number
  pageNum?: number
  setPageNum?: (value: number) => void
  setPageSize?: (value: number) => void
  // setTotalRecord?: (totalNum: number) => void
  onPageChange?: (pageNum: number, pageSize: number) => void
  onRowsPerPageChange?: (pageNum: number, pageSize: number) => void
  rowsPerPageOptions?: Array<number>
  stickyHeader?: boolean
  sortColumn?: TableSortColumnInfo
  showPaginationEnTranslation?: boolean
}

export const makeTableStyles = makeStyles({
  root: {
    '& .MuiTableHead-root': {
      backgroundColor: '#F4F4F4'
    },
    '& .MuiTableCell-head': {
      borderLeft: '1px solid rgba(224, 224, 224, 1)',
      color: '#58647A',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 700
    },
    '& .MuiTableCell-body': {
      borderLeft: '1px solid rgba(224, 224, 224, 1)',
      color: '#1C1D1F',
      fontSize: 14,
      fontStyle: 'normal',
      fontWeight: 400
    }
  },
  hightLightCell: {
    backgroundColor: '#ed1b2e26'
  }
})

export const HightLightTable = (props: HightLightTableProps) => {
  const {
    dataSource,
    tableContainerClassName,
    displayedColumns,
    onPageChange,
    onRowsPerPageChange,
    totalRecord = 0,
    isPagination,
    pageNum = 0,
    pageSize = 10,
    setPageNum,
    setPageSize,
    // setTotalRecord,
    rowsPerPageOptions,
    stickyHeader,
    sortColumn,
    showPaginationEnTranslation
  } = props
  const tableClasses = makeTableStyles()
  const { t } = useTranslation()
  const [documentList, setDocumentList] = React.useState<TableDataSource[]>([])
  const [sortItem, setSortItem] = React.useState<{ field: string; order: 'asc' | 'desc' | undefined }>({
    field: '',
    order: 'asc'
  })
  React.useMemo(() => {
    setDocumentList(dataSource)
  }, [dataSource])

  React.useMemo(() => {
    if (sortColumn) {
      setSortItem(sortColumn)
    }
  }, [sortColumn])
  return (
    <View style={tableStyles.tableContainer}>
      <TableContainer component={Paper} className={tableContainerClassName}>
        <Table classes={{ root: tableClasses.root }} stickyHeader={stickyHeader}>
          <TableHead>
            <TableHeaderSort
              data={documentList}
              setData={setDocumentList}
              setSortItem={setSortItem}
              sortItem={sortItem}
              column={[
                ...displayedColumns.map((columnItem) => {
                  return {
                    label: columnItem.title,
                    field: columnItem.fieldName,
                    disabled: columnItem.disabled
                  }
                })
              ]}
            />
          </TableHead>
          <TableBody>
            {documentList &&
              documentList.length > 0 &&
              documentList.map((documentItem, index) => {
                return (
                  <TableRow key={`metricDetailRow_${index}`}>
                    {displayedColumns.map((col, subIndex) => {
                      return (
                        <TableCell
                          key={`metricDetailCol_${subIndex}`}
                          classes={
                            col.isHightLightCol && col.isHightLightCol({ index: index, selectItem: documentItem })
                              ? { root: tableClasses.hightLightCell }
                              : {}
                          }
                        >
                          {col.rowRender
                            ? col.rowRender({ index: index, selectItem: documentItem })
                            : documentItem[col.fieldName]}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                )
              })}
          </TableBody>
        </Table>
      </TableContainer>
      {isPagination && (
        <TablePagination
          rowsPerPageOptions={rowsPerPageOptions ?? [10, 20]}
          count={totalRecord}
          rowsPerPage={pageSize}
          page={pageNum}
          onPageChange={(e, page) => {
            setPageNum && setPageNum(page)
            onPageChange && onPageChange(page, pageSize)
          }}
          onRowsPerPageChange={(e) => {
            const pageS = Number(e.target.value)
            setPageSize && setPageSize(pageS)
            if (totalRecord <= pageNum * pageS) {
              setPageNum && setPageNum(0)
              onRowsPerPageChange && onRowsPerPageChange(0, pageS)
            } else {
              onRowsPerPageChange && onRowsPerPageChange(pageNum, pageS)
            }
          }}
          labelRowsPerPage={
            showPaginationEnTranslation ? t('AdministratorConfig:PaginationSize') : t('common:PaginationSize')
          }
          labelDisplayedRows={({ from, to, count }) =>
            showPaginationEnTranslation
              ? t('AdministratorConfig:Pagination', { from, to, count })
              : t('common:Pagination', { from, to, count })
          }
          component={View}
        ></TablePagination>
      )}
    </View>
  )
}

const tableStyles = StyleSheet.create({
  tableContainer: {
    marginVertical: 24
  }
})
